import { render, staticRenderFns } from "./MessageListItem.vue?vue&type=template&id=68e7c8d8&"
import script from "./MessageListItem.vue?vue&type=script&lang=js&"
export * from "./MessageListItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports